// extracted by mini-css-extract-plugin
export default {"col":"PositiveResult_col__l6iLF","back":"PositiveResult_back__e0DE4","indent":"PositiveResult_indent__uN49e"};